export default __webpack_public_path__ + "static/media/hht2_storybook_01.73e5a97c.png";